import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { Auth0Plugin } from "./auth";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faLink,
  faUser,
  faPowerOff,
  faCog,
  faBatteryEmpty,
  faBatteryFull,
  faBatteryQuarter,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { content } from "../config/config.js";
import "./assets/sass/layout.scss";

import * as VueGoogleMaps from "vue2-google-maps";
import VueGoogleCharts from "vue-google-charts";
import vuetify from "@/plugins/vuetify";
import utility from "@/plugins/utility";
import store from "./store";
import JsonCSV from "vue-json-csv";
import VueClipboard from "vue-clipboard2";
import { i18n } from "@/plugins/i18n";
import FlagIcon from "vue-flag-icon";

Vue.use(VueGoogleCharts);
Vue.use(utility);
Vue.use(VueClipboard);
Vue.use(FlagIcon);

const domain = process.env.VUE_APP_AUTH0_DOMAIN;
const clientId = process.env.VUE_APP_AUTH0_CLIENTID;
const audience = process.env.VUE_APP_AUTH0_AUDIENCE;

// Google maps for viue
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAz5CWu9H_HdYbca-MOfDuw9pzKothYCd4",
    //libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

Vue.config.productionTip = false;

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: (appState) => {
    router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
  },
});

library.add(faLink, faUser, faPowerOff, faCog, faBatteryEmpty, faBatteryFull, faBatteryQuarter, faLink);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("downloadCsv", JsonCSV);
Vue.prototype.$config = content;
const INSTANCE = new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: (h) => h(App),
  created() {
    this.$store.dispatch("initializeTheme");
  },
}).$mount("#app");

export const { $config, $store, $auth } = INSTANCE;
